//认证相关工具方法；
import Cookies from 'js-cookie'
//公共的配置文件；
import Config from '@/config'

const TokenKey = Config.TokenKey

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token, rememberMe) {
  if (rememberMe) {
    return Cookies.set(TokenKey, token, { expires: Config.tokenCookieExpires })
  } else return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}




// WEBPACK FOOTER //
// ./src/utils/auth.js